import { Outlet } from "react-router-dom";
import Cookie from "js-cookie"
import { DataProvider } from "./employerContext";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { encryptData } from "Security/Crypto/Crypto";
import { useCustomNavigate } from "ReusableFunctions/CustomHooks";

const EmployerRequireAuth = () => {
  const pageRender = useCustomNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const prof_id = queryParams.get("prof_id");
  const job_id = queryParams.get("job_id");
  const id = queryParams.get("id");
  const user_id = queryParams.get("emp_id");

  if (prof_id || job_id || id) {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);

      if (prof_id) {
        if (prof_id.includes("2C-PR")) {
          if (Cookie.get("Prof_id")) Cookie.remove("Prof_id")
          if (!Cookie.get("Prof_id")) Cookie.set("Prof_id", encryptData(prof_id))
        } else {
          if (Cookie.get("Prof_id")) Cookie.remove("Prof_id")
          if (!Cookie.get("Prof_id")) Cookie.set("Prof_id", prof_id)
        }
      }

      if (id) Cookie.set("Prof_id", id);

      if (job_id) Cookie.set("job_id", job_id);
    }
  }

  useEffect(() => {
    if (user_id && Cookie.get("id") !== user_id) {
      Cookie.remove("eToken");
      Cookie.remove("id");
      toast.error("Not allowed");
      pageRender("/")
    }
  }, []);

  return (
    <DataProvider>
      <Outlet />
    </DataProvider>
  )
};

export default EmployerRequireAuth;
